import { render, staticRenderFns } from "./celebrity.vue?vue&type=template&id=58292748&"
import script from "./celebrity.vue?vue&type=script&lang=js&"
export * from "./celebrity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports